export default [
  {
    partnerName: "Universal Trading Company",
    january: 0,
    february: 0,
    march: 1,
    april: 0,
    may: 2,
    june: 0,
    july: 0,
    august: 1,
    september: 2,
    october: 0,
    november: 0,
    december: 0,
    totalDays: 6,
  },
  {
    partnerName: "Ali Abdul Wahab Al Muttawa Commercial CO",
    january: 0,
    february: 0,
    march: 0,
    april: 0,
    may: 1,
    june: 0,
    july: 0,
    august: 0,
    september: 0,
    october: 0,
    november: 0,
    december: 0,
    totalDays: 1,
  },
  {
    partnerName: "Silver Sands PVT LTD",
    january: 0,
    february: 0,
    march: 1,
    april: 0,
    may: 0,
    june: 0,
    july: 0,
    august: 0,
    september: 2,
    october: 0,
    november: 0,
    december: 0,
    totalDays: 3,
  },
  {
    partnerName: "TOTAL",
    january: 0,
    february: 1,
    march: 1,
    april: 0,
    may: 2,
    june: 1,
    july: 1,
    august: 1,
    september: 3,
    october: 0,
    november: 0,
    december: 0,
    totalDays: 3,
  }
];
